app.controller("PollsWindowController", ["$scope", "$uibModalInstance", "params", "PollService",
    function ($scope, $uibModalInstance, params, PollService) {
        $scope.info = params.info;
        $scope.poll = params.poll;
        $scope.anonymous = params.poll.anonymous;

        $scope.init = function () {
            if (params.info)
                $scope.answer = params.poll.type === 'options' ? params.poll.answers[params.info.answer] : params.info.answer;
        };

        $scope.init();

        $scope.close = function () {
            $uibModalInstance.dismiss();
        };

        $scope.submit = function (answer) {
            if (!$scope.info._id && $scope.poll.state === 'answered') return $uibModalInstance.dismiss();
            PollService.mark({
                poll: $scope.info._id,
                state: answer !== undefined ? 'answered' : 'read',
                answer: answer
            }).then(function (poll) {
                $uibModalInstance.close(poll);
            })
        }
    }
]);
